import { render, staticRenderFns } from "./SalemanWebSetting.vue?vue&type=template&id=46c1b3b3&scoped=true&"
import script from "./SalemanWebSetting.vue?vue&type=script&lang=js&"
export * from "./SalemanWebSetting.vue?vue&type=script&lang=js&"
import style0 from "./SalemanWebSetting.vue?vue&type=style&index=0&id=46c1b3b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1b3b3",
  null
  
)

export default component.exports